import { useState } from "react";

const ScaffoldTableRow = ({ item }) => {
  const [showMore, setShowMore] = useState(false);

  const scaffolds = item.scaffoldName || []; // adjust based on your actual data key
  const firstScaffold = scaffolds[0];
  const remainingScaffolds = scaffolds.slice(1);

  return (
    <tr>
      {/* Title Column */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">
          {firstScaffold?.key || "N/A"}
        </div>

        {/* View More Toggle */}
        {remainingScaffolds.length > 0 && (
          <div className="mt-1 text-xs text-blue-600 cursor-pointer" onClick={() => setShowMore(!showMore)}>
            {showMore ? "View Less" : "View More"}
          </div>
        )}

        {/* Hidden scaffold items */}
        {showMore && (
          <ul className="mt-2 text-sm text-gray-700 list-disc list-inside">
            {remainingScaffolds.map((scaffold, index) => (
              <li key={index}>{scaffold.key}</li>
            ))}
          </ul>
        )}
      </td>
    </tr>
  );
};

export default ScaffoldTableRow